import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=68c9e0e1&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=68c9e0e1&prod&scoped=true&lang=css"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=68c9e0e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c9e0e1",
  null
  
)

export default component.exports